import React, { Fragment } from 'react'
import { css } from 'styled-components/macro'
import { useFetch } from 'use-http'
import { useQueryParams, NumberParam, StringParam } from 'use-query-params'

import {
	useHandlerState,
	useHandlerDispatch,
} from '../../context/HandlerProvider'

import Button, { ButtonVariant } from '../../components/Button'
import Alert, { AlertVariant } from '../../components/Alert'
import Footer from '../../components/Footer'

import { SurveyDefinitionType, SurveySubmitType } from '../../types'
import { generatePageAnswer } from '../../utils'
import { useEffect } from 'react'

const parentWindow = window.parent !== window ? window.parent : window.opener

const getExorliveLocation = () => {
	//if (window.location.hostname === 'survey.exorlive.com') {
	//	return process.env.REACT_APP_EXORLIVE_URL
	//} else if (window.location.hostname === 'survey-test.exorlive.com') {
	//	return process.env.REACT_APP_EXORLIVE_API_URL
	//} else {
	//	return '*'
	//}

	return '*'
}

const SurveySubmit = ({
	translations,
	surveyDefinition,
	currentQuestion,
}: SurveySubmitProps) => {
	const handlerDispatch = useHandlerDispatch()
	const { confirmedAnswers } = useHandlerState()

	const [queryParams] = useQueryParams({
		userId: NumberParam,
		orgId: NumberParam,
		deptId: NumberParam,
		hash: StringParam,
		culture: StringParam,
	})

	const { userId, orgId, deptId, hash } = queryParams

	const [requestToSurvey, responseFromSurvey, isSurveyLoading, surveyError] =
		useFetch(process.env.REACT_APP_SURVEY_API_URL, {
			credentials: 'include',
		})

	useEffect(() => {
		if (responseFromSurvey.status === 202 && !isSurveyLoading) {
			parentWindow &&
				parentWindow.postMessage({ task: 'suggestions' }, getExorliveLocation())
		}
	}, [responseFromSurvey.status, isSurveyLoading])

	if (!confirmedAnswers) return null

	const formattedSurveyAnswerData = {
		$type: 'AnsweredSurvey',
		OrgId: orgId,
		DeptId: deptId,
		Locked: true, // Not sure what this does [AW]
		PageAnswers: confirmedAnswers
			?.map((confirmedAnswer) => generatePageAnswer(confirmedAnswer))
			.filter(Boolean),
		SurveyId: surveyDefinition.id,
		TimeStamp: Date.now(),
		UserId: userId,
	}

	const sendAnsweredSurvey = () => {
		requestToSurvey.post(
			`/api/answer/${userId}/${orgId}/${deptId}/${hash}`,
			formattedSurveyAnswerData
		)
	}

	const onBackClick = () => {
		handlerDispatch({
			type: 'navigateBack',
		})

		window.scrollTo(0, 0)
	}

	return (
		<Fragment>
			<main>
				<div className='submitTextContainer'>
					<h1>{translations[currentQuestion.headerTextKey]}</h1>
					<p
						css={`
							white-space: pre-line;
						`}
					>
						{translations[currentQuestion.ingressTextKey]}
					</p>
					{!isSurveyLoading && surveyError ? (
						<Alert variant={AlertVariant.error}>
							<p>{translations['LabelGenericError']}</p>
						</Alert>
					) : null}
				</div>
			</main>
			<Footer>
				<div
					css={css`
						display: flex;
						justify-content: flex-end;
						margin-bottom: 1rem;
						gap: 1rem;
					`}
				>
					{isSurveyLoading ? (
						<Fragment>
							<Button type='button' variant={ButtonVariant.secondary} disabled>
								{translations['ButtonBack']}
							</Button>
							<Button type='button' variant={ButtonVariant.primary}>
								{translations['LabelLoading']}
							</Button>
						</Fragment>
					) : (
						<Fragment>
							<Button
								type='button'
								variant={ButtonVariant.secondary}
								onClick={onBackClick}
							>
								{translations['ButtonBack']}
							</Button>
							<Button
								variant={ButtonVariant.primary}
								type='button'
								onClick={() => sendAnsweredSurvey()}
							>
								{translations['ButtonFinishKey']}
							</Button>
						</Fragment>
					)}
				</div>
			</Footer>
		</Fragment>
	)
}

export default SurveySubmit

interface SurveySubmitProps {
	translations: {
		[translationKey: string]: string
	}
	surveyDefinition: SurveyDefinitionType
	currentQuestion: SurveySubmitType
}
